import { type ObjectValuesUnionType } from '../utils/typing';

export const OddButtonThemes = Object.freeze({
  GREEN: 'green',
  OUTLINE_GREEN: 'outlineGreen',
  BLUE: 'blue',
  OUTLINE_BLUE: 'outlineBlue',
});

export type OddButtonThemesType = ObjectValuesUnionType<typeof OddButtonThemes>;
